let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cnozD")).then(() => parcelRequire('bP5KU'));